<script setup lang="ts">
import { DBLocalGenericIcon } from "@/enumLocal/icon";
import { RouterView } from "vue-router";
import { useCustomizerStore } from "../../stores/customizer";
import Customizer from "./customizer/Customizer.vue";
import HorizontalHeader from "./horizontal-header/HorizontalHeader.vue";
import HorizontalSidebar from "./horizontal-sidebar/HorizontalSidebar.vue";
import VerticalHeaderVue from "./vertical-header/VerticalHeader.vue";
import VerticalSidebarVue from "./vertical-sidebar/VerticalSidebar.vue";
const open = shallowRef(false);
/*import {
  Customizer,
  HorizontalHeader,
  HorizontalSidebar,
  VerticalHeaderVue,
  VerticalSidebarVue,
} from "@/utils/asyncLoading";*/
import { router } from "@/plugins/router";
import { mainRoutesName } from "@/plugins/router/routeName";
import loggerLocal from "@/utils/loggerLocal";
import { useDisplay } from "vuetify";

const customizer = useCustomizerStore();
const { mobile } = useDisplay();
onMounted(() => loggerLocal.info("[FullLayout] mounted"));

function goToCreate() {
  router.push({ name: mainRoutesName.newQuote });
}
</script>

<template>
  <!-----RTL LAYOUT------->
  <v-locale-provider v-if="customizer.setRTLLayout" rtl>
    <v-app
      :theme="customizer.actTheme"
      class="bg-containerBg"
      :class="[
        customizer.actTheme,
        customizer.mini_sidebar ? 'mini-sidebar' : '',
        customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
        customizer.setBorderCard ? 'cardBordered' : '',
      ]"
    >
      <!---Customizer location left side--->
      <v-navigation-drawer
        app
        temporary
        elevation="10"
        location="left"
        v-model="customizer.Customizer_drawer"
        width="320"
        class="left-customizer"
      >
        <Customizer />
      </v-navigation-drawer>
      <VerticalSidebarVue v-if="!customizer.setHorizontalLayout" />
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <VerticalHeaderVue v-if="!customizer.setHorizontalLayout" />
      </div>
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <HorizontalHeader v-if="customizer.setHorizontalLayout" />
      </div>
      <HorizontalSidebar v-if="customizer.setHorizontalLayout" />

      <v-main class="ml-md-4">
        <div class="rtl-lyt mb-3 hr-layout bg-containerBg">
          <v-container fluid class="page-wrapper bg-background pt-md-8 rounded-xl">
            <div>
              <div :class="customizer.boxed ? 'maxWidth' : ''">
                <RouterView />
                <!--<v-btn
                  class="customizer-btn"
                  size="large"
                  icon
                  variant="flat"
                  color="primary"
                  @click.stop="
                    customizer.SET_CUSTOMIZER_DRAWER(!customizer.Customizer_drawer)
                  "
                >
                  <SettingsIcon />
                </v-btn>-->
                <v-fab
                  :app="true"
                  :color="open ? '' : 'primary'"
                  :location="'right bottom'"
                  size="large"
                  icon
                  @click="goToCreate()"
                >
                  <Iconify :icon="DBLocalGenericIcon.plus" height="35"></Iconify>
                </v-fab>
              </div>
            </div>
          </v-container>
        </div>
      </v-main>
    </v-app>
  </v-locale-provider>

  <!-----LTR LAYOUT------->
  <v-locale-provider v-else>
    <v-app
      :theme="customizer.actTheme"
      class="bg-containerBg"
      :class="[
        customizer.actTheme,
        customizer.mini_sidebar ? 'mini-sidebar' : '',
        customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
        customizer.setBorderCard ? 'cardBordered' : '',
      ]"
    >
      <!---Customizer location right side--->
      <v-navigation-drawer
        app
        temporary
        elevation="10"
        location="right"
        v-model="customizer.Customizer_drawer"
        width="320"
      >
        <Customizer />
      </v-navigation-drawer>
      <VerticalSidebarVue v-if="!customizer.setHorizontalLayout" />
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <VerticalHeaderVue v-if="!customizer.setHorizontalLayout" />
      </div>
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <HorizontalHeader v-if="customizer.setHorizontalLayout" />
      </div>
      <HorizontalSidebar v-if="customizer.setHorizontalLayout" />

      <v-main class="mr-md-4">
        <div class="mb-1 hr-layout bg-containerBg">
          <v-container fluid class="page-wrapper bg-background pt-md-4 rounded-xl">
            <div>
              <div :class="customizer.boxed ? 'maxWidth' : ''">
                <RouterView />
                <!--<v-btn
                  class="customizer-btn"
                  size="large"
                  icon
                  variant="flat"
                  color="primary"
                  @click.stop="
                    customizer.SET_CUSTOMIZER_DRAWER(!customizer.Customizer_drawer)
                  "
                >
                  <SettingsIcon />
                  
                </v-btn>-->
                <v-fab
                  :app="true"
                  :color="open ? '' : 'primary'"
                  :location="'right bottom'"
                  size="large"
                  icon
                  @click="goToCreate()"
                >
                  <Iconify :icon="DBLocalGenericIcon.plus" height="35"></Iconify>
                </v-fab>
              </div>
            </div>
          </v-container>
        </div>
      </v-main>
    </v-app>
  </v-locale-provider>
</template>
